import React, { useContext } from 'react'
import { Text, View } from 'oio-react'
import { InitiativeHierarchyContext } from 'src/libraries/contexts/InitiativeHierarchy'

const InitaitiveTagsBlock = () => {
   const { initiative } = useContext(InitiativeHierarchyContext)

   return initiative.tags.length > 0 && (
      <View
         float="left"
         width="100%"
         paddingVertical="20px[a-d] 20px[e-f]"
         borderTop="1px solid #ececec">
         <View maxWidth="650px" marginTop="10px">
            {initiative.tags.map(tag => (
               <View
                  key={tag}
                  display="inline-flex"
                  alignItems="center"
                  height="25px"
                  padding="0px 10px"
                  borderRadius="2px"
                  marginRight="10px"
                  marginBottom="10px"
                  backgroundColor="#eee">
                  <Text size="2" color="#888">{tag}</Text>
               </View>
            ))}
         </View>
      </View>
   )
}

export default InitaitiveTagsBlock
